<template>
<div class="row">
  <div class="col-sm-12">
      <router-link :to="{name:'dossier_creation'}" class="btn btn-primary"><i class="fa fa-plus"></i> Créer un dossier</router-link>
  </div>
  <div class="col-sm-12" style="margin:0;padding-top:15px">
    <div class="table-responsive">
      <GridGeneral
      :data="dossiers"
      :columns="gridColumns"
      :sortColumns="gridColumnsSort"
      :loadData="refresh">
      </GridGeneral>
    </div>
  </div>
</div>
</template>

<script>
import GridGeneral from '@/components/GridGeneral.vue'

import axios from 'axios';

export default {
  name: 'ServiceProviderDossier',
  props: ['oziweb_wp_url'],
  data: function() {return {
    dossier:'',
    serviceprovider:{},
    designation_dossier_id:'',
    service_provider_id:'',
    dossiers:{},
    sort:'',
    sortOrder:1,
    gridColumnsName: ['Dossiers',"Dernière entrée d'historique",'Liste des services'],
    gridColumns: [{field:'dossier',title:'Dossiers'},{field:'status',title:'Dernière entrée d\'historique'},{field:'services',title:'Liste des services'}],
    gridColumnsSort : ['dossier','status'],
  }},

  components: {
    GridGeneral,
  },
  methods: {

    newStart:  function (field) {
      //this.startRow = 0;
      //this.fromRow = 1;
      this.refresh();
    },


    refresh: function() {
      axios
        .get(this.$root.$data.server_base + '/api/service_provider_dossiers.php',
          { params: {sort:this.sort,sortOrder:this.sortOrder,service_provider_id: this.$route.params.service_provider_id}})
        .then(response => (this.$checkApiErrors(response.data),this.serviceprovider = response.data.serviceprovider,this.dossiers = response.data.dossiers))
    },
    


  },
  mounted () {
    this.refresh()
    this.service_provider_id=this.$route.params.service_provider_id;
  }
}
</script>
